import React, { createContext, useState, useContext } from 'react';

const SelectContext = createContext();

export function SelectProvider({ children }) {
  const [selection, setSelection] = useState({});

  const updateSelection = (name, value) => {
    setSelection(prev => ({ ...prev, [name]: value }));
  };

  return (
    <SelectContext.Provider value={{ selection, updateSelection }}>
      {children}
    </SelectContext.Provider>
  );
}

export function useSelectContext() {
  return useContext(SelectContext);
}
